module.exports = __webpack_public_path__ + "img/open_app_active.fa1183f.svg";